/**
 * @Desription: 登录-方法管理
 * @Author: netstar.sjj
 * @Date: 2021-10-25 16:05:00
 * @class controllerManager
*/
declare const window:any;
namespace controllerManager{
    //去主页
    export function toHomePage(authCode:any,options?:any){
        options = typeof(options)=='object' ? options : {};
        //跳转页面 没有参数加 ? 有则加 &
        let config:any = window.NSLogin.config;
        let mainPageUrl:string = config.mainPage.url;
        let currentInnerUrl:string = window.location.href;
        let result:any = {};
        let searchParams:any = decodeURI(window.location.search);
        let params:any = searchParams.slice(1).split('&');
        for (let i = 0; i < params.length; i++) {
            let idx = params[i].indexOf('=');
            if (idx > 0) {
                result[params[i].substring(0, idx)] = params[i].substring(idx + 1);
            }
        }
        //删除地址栏中的url参数，url中的参数不应当保持向下传递 start------
        let paramsIndex:number = currentInnerUrl.indexOf('?');
        if(paramsIndex>0){
            currentInnerUrl = currentInnerUrl.substr(0, paramsIndex);
        }
        let urlParamsStr:string = 'form=login&source=' + encodeURI(currentInnerUrl);
        for(let searchI in result){
            urlParamsStr += '&'+searchI+'='+result[searchI];
        }
        for(let keyOptionI in options){
            urlParamsStr += '&'+keyOptionI+'='+options[keyOptionI];
        }
        if(mainPageUrl.indexOf('?') == -1){
            mainPageUrl = mainPageUrl + '?' + urlParamsStr;
        }else{
            mainPageUrl = mainPageUrl + '&' + urlParamsStr;
        }
        let addressWindowParams:any = window.NSUtils.getUrlPara();
        if(addressWindowParams.service){
            window.store.set('NSLOGINSERVICEADDRESS',addressWindowParams.service);
        }
        if(config.mainPage && config.mainPage.beforeHandler){
            //如果有前置回调方法则等待前置回调方法执行完以后再执行跳转
            config.mainPage.beforeHandler(authCode, function(){
                window.location.href = mainPageUrl;
            })
        }else{
            window.location.href = mainPageUrl;
        }
    }
    //自动登录 举例?token 
    export function sso(config:any) {
        let params:any = window.NSUtils.getUrlPara();
        if(params.loginsource){
            const loginSourceData:any = {
                title:window.jQuery('title').html(),
                loginSource:params.loginsource
            };
            window.store.set('loginSourceProperty',loginSourceData);//定义了登录来源 比如通过企业微信 sjj 20220429 
        }
        if(typeof(params.token) == 'undefined' && typeof(params.jobNumber) == 'undefined' && typeof(params.ticket) == 'undefined' && typeof(params.code) == 'undefined' && typeof(params["auth_code"]) == 'undefined'){
            window.jQuery('.pt-login-loading').remove();//非自动登录
        }else{
            let loginUrl:string = config.loginUrl;
            if(loginUrl.indexOf('?')>0 && loginUrl.indexOf('token')>0){
                config.loginUrl = loginUrl.substr(0, loginUrl.indexOf('?'));
            }
            if(loginUrl.indexOf('?')>0 && loginUrl.indexOf('jobNumber')>0){
                config.loginUrl = loginUrl.substr(0, loginUrl.indexOf('?'));
            }
            let ajaxParams:any = {};
            let ssoUrl:string = window.NSUtils.getAPIUrl() + 'login/yiling/jobNumberLogin';
            if(typeof(window.NetstarApiConfig)=='object' && !window.jQuery.isEmptyObject(window.NetstarApiConfig.changeTokenAjax)){
                ssoUrl = window.NetstarApiConfig.changeTokenAjax.url;
                if(!window.jQuery.isEmptyObject(window.NetstarApiConfig.changeTokenAjax.data)){
                    ajaxParams = window.NSUtils.getFormatParameterJSON(window.NetstarApiConfig.changeTokenAjax.data,params);
                }else{
                    for(let key in params){
                        if(key != ''){
                            ajaxParams[key] = params[key];
                        }
                    }
                }
            }else{
                for(let key in params){
                    if(key != ''){
                        ajaxParams[key] = params[key];
                    }
                }
            }
            window.jQuery('body').addClass('login-page-loading');
            //原来changeTokenAjax.type写死成POST 改为读取参数 cy 20220115
            let ajaxType = "POST";
            if( typeof(window.NetstarApiConfig.changeTokenAjax) == 'object' && typeof(window.NetstarApiConfig.changeTokenAjax.type) == 'string'){
                ajaxType = window.NetstarApiConfig.changeTokenAjax.type;
            }
            if(typeof(params.code) !== 'undefined'|| typeof(params["auth_code"]) !== 'undefined'){
                ssoUrl =  window.NSUtils.getAPIUrl() + "workweixin/workWeixinUser/login";
                ajaxType = "GET";
            }
            window.jQuery.ajax({
                url:ssoUrl,
                data:ajaxParams,
                type:ajaxType,
                contentType: 'application/x-www-form-urlencoded',
                success:function(res:any){
                    const toRelocationFunc:Function = function(){
                        window.jQuery('.pt-login-loading').remove();
                        window.jQuery('body').removeClass('login-page-loading');
                        if(window.NetstarApiConfig.serviceLogoutUrl){
                            let loginUrl = window.NSUtils.getUrlPara().source;
                            let logoutUrl = window.NetstarApiConfig.serviceLogoutUrl;
                            if(typeof(loginUrl)=='undefined'){
                                if(typeof(window.homePageConfig)=='object' && typeof(window.homePageConfig.loginConfig)=='object' && window.homePageConfig.loginConfig.loginUrl){
                                    loginUrl = window.homePageConfig.loginConfig.loginUrl;
                                }
                            }
                            if(window.NetstarApiConfig.serviceLoginUrl){
                                let innerLoginUrl = window.NetstarApiConfig.serviceLoginUrl+'?service='+loginUrl;
                                logoutUrl += '?service='+encodeURIComponent(innerLoginUrl);
                            }else{
                                logoutUrl += '?service='+encodeURIComponent(loginUrl);
                            }
                            window.location.href = logoutUrl;
                        }else{
                            window.nsalert(window.language.login.autoError, 'error');
                            console.error(window.language.login.autoError, res); 
                        }
                    };
                    if(res.success == false){
                        toRelocationFunc();
                        return;
                    }
                    if(typeof(res.data) == 'undefined'){
                        toRelocationFunc();
                        return;
                    }
                    if(res.data.success == false){
                        toRelocationFunc();
                        return;
                    }
                    window.NSLogin.serverData = res;
                    window.NSLogin.loginRes = res;
                    window.NSLogin.Authorization = res.data.token;
                    if(typeof(res.data.properties)=='object'){
                        if(typeof(res.data.properties.context)=='object'){
                            res.data.properties.context.envType = res.data.envType;
                        }
                        window.store.set('loginProperty',res.data.properties);//登录成功之后获取系统用户信息
                    }
                    window.NSUtils.OAuthCode.set({
                        authorization:      res.data.token, 
                        expireMinute:       config.expireMinute,
                        loginTimeStamp:     new Date().getTime(),
                    });
                    window.NSLogin.toHomePage(window.NSLogin.Authorization);
                },
                error:function(error:any){
                    window.jQuery('.pt-login-loading').remove();
                    window.jQuery('body').removeClass('login-page-loading');
                    if(window.NetstarApiConfig.serviceLogoutUrl){
                        let loginUrl = window.NSUtils.getUrlPara().source;
                        let logoutUrl = window.NetstarApiConfig.serviceLogoutUrl;
                        if(typeof(loginUrl)=='undefined'){
                            if(typeof(window.homePageConfig)=='object' && typeof(window.homePageConfig.loginConfig)=='object' && window.homePageConfig.loginConfig.loginUrl){
                                loginUrl = window.homePageConfig.loginConfig.loginUrl;
                            }
                        }
                        if(window.NetstarApiConfig.serviceLoginUrl){
                            let innerLoginUrl = window.NetstarApiConfig.serviceLoginUrl+'?service='+loginUrl;
                            logoutUrl += '?service='+encodeURIComponent(innerLoginUrl);
                        }else{
                            logoutUrl += '?service='+encodeURIComponent(loginUrl);
                        }
                        window.location.href = logoutUrl;
                    }else{
                        window.nsalert(window.language.login.autoError, 'error');
                        console.error(window.language.login.autoError, error);
                    }
                }
            })
        }
    }
}
export default controllerManager;